import { cards } from '@/mocks/home';

const tagColors: Record<string, string> = {
  '新作': 'bg-accent-100 text-accent-700',
  '完结': 'bg-primary-100 text-primary-700',
  '冷门': 'bg-secondary-100 text-secondary-700',
  '恋爱': 'bg-primary-100 text-primary-700',
  '热血': 'bg-accent-100 text-accent-700',
};

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">精选推荐</h2>
          <p className="mt-2 text-sm text-foreground-500">编辑精心挑选的韩漫合集，总有一部适合你</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.slice(0, 3).map((card, i) => (
            <div key={i} className="bg-background-50 rounded-xl overflow-hidden cursor-pointer hover:ring-2 hover:ring-primary-200 transition-all">
              <div className="relative overflow-hidden" style={{ aspectRatio: '3/2' }}>
                <img src={card.image} alt={card.title} className="w-full h-full object-cover" />
                <span className={`absolute top-3 left-3 text-xs font-medium px-2.5 py-1 rounded-full ${tagColors[card.tag] || 'bg-background-200 text-foreground-600'}`}>
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-bold font-heading text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {cards.slice(3, 5).map((card, i) => (
            <div key={i + 3} className="bg-background-50 rounded-xl overflow-hidden cursor-pointer hover:ring-2 hover:ring-primary-200 transition-all flex flex-col sm:flex-row">
              <div className="relative overflow-hidden sm:w-2/5" style={{ aspectRatio: '3/2' }}>
                <img src={card.image} alt={card.title} className="w-full h-full object-cover" />
                <span className={`absolute top-3 left-3 text-xs font-medium px-2.5 py-1 rounded-full ${tagColors[card.tag] || 'bg-background-200 text-foreground-600'}`}>
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5 sm:w-3/5 flex flex-col justify-center">
                <h3 className="text-base font-bold font-heading text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}